import React, { memo } from 'react';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import FiftyFifty from '../FiftyFifty/FiftyFifty';
import Heading, { HeadingTypes } from '../Heading/Heading';
import Subtitle from '../Subtitle/Subtitle';
import { Blok } from '../../interfaces/Blok.interface';
import { Media } from '../../interfaces/Media.interface';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import RichText, { screenWidth } from '../RichText/RichText';
import { StoryblokComponent } from 'gatsby-source-storyblok';

interface ContentAndMediaBlokProps extends Blok {
  subtitle: string;
  heading: string;
  body: StoryblokRichtext;
  cta: Blok[];
  reverse: boolean;
  media: Media[];
  is_bottom_padding_required: boolean;
}

interface ContentAndMediaProps extends Blok {
  blok: ContentAndMediaBlokProps;
  children: React.ReactNode;
}

const ContentAndMedia: React.FC<ContentAndMediaProps> = ({
  blok: { subtitle, heading, body, cta },
  blok,
}) => {
  return (
    <FiftyFifty blok={blok}>
      <div className="w-full text-center lg:text-left">
        {subtitle && <Subtitle text={subtitle} />}
        {heading && (
          <Heading
            text={heading}
            headingType={HeadingTypes.h2}
            className="pb-6 pt-4"
          />
        )}
        {body && (
          <div className="pb-6 sm:pb-10">
            <RichText content={body} centerResponsively={screenWidth.LG} />
          </div>
        )}
        {cta.map((cta_item: Blok) => (
          <StoryblokComponent blok={cta_item} key={cta_item._uid} />
        ))}
      </div>
    </FiftyFifty>
  );
};

export default memo(withBlokWrapper(ContentAndMedia));
